import {Component, OnInit, ViewEncapsulation, Input} from '@angular/core';

@Component({
    selector: 'print-list-confirmed',
    templateUrl: './print-list-confirmed.html',
    encapsulation: ViewEncapsulation.None
})
export class PrintListConfirmedComponent implements OnInit {

    @Input() date: string;
    @Input() mj: number;
    @Input() mp: number;
    @Input() text: string;

    constructor() {
    }

    ngOnInit() {
        console.log(this.text);
    }

}
